// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"133":"db32a618","344":"6f15e2f3","422":"23223abd","492":"abf8429a","587":"47dcbb9a","640":"648db4c2","727":"8182abfd","771":"d6734b81"}[chunkId] + ".chunk.js";
};